const PHI_MASK = '**REDACTED**'
const DEFAULT_REDACTABLE_INTAKE_QUESTION_TYPES = ['text', 'date', 'number']

const FREE_TEXT_FIELDS = [
  'patientFirstName',
  'patientLastName',
  'patientMRN',
  'patientDOB',
  'providerFirstName',
  'providerLastName',
  'callerFirstName',
  'callerLastName',
  'notes',
  'supervisorNotes',
  'parsedNotes',
  'phoneNumberAC',
  'customerPhoneNumber',
  'memberIdNumber',
  'nyuAccessCode',
  'sentaraAccessCode',
  'ivrAccessCode',
]

const toRedacted = (payload) => {
  const redact = (obj) => {
    const result = {}
    for (const [key, value] of Object.entries(obj)) {
      result[key] = FREE_TEXT_FIELDS.includes(key) && value ? PHI_MASK : value
    }
    return result
  }

  try {
    return redact(payload)
  } catch (err) {
    return { redactionError: true }
  }
}

const toLoggableIntakeAnswers = (answers = [], redactableTypes = DEFAULT_REDACTABLE_INTAKE_QUESTION_TYPES) => {
  try {
    if (!answers) {
      return []
    }

    return answers.map((item) => {

      // Find the question
      const definition = item.intakeQuestion;

      // Extract info (with fallbacks)
      const questionTitle = definition?.title || "Unknown Question"
      const itemType = definition?.itemType || "text"

      // Decide if we should redact with redactableTypes
      const shouldRedact = redactableTypes.includes(itemType)

      // Return safe to log version
      return {
        questionId: item.questionId,
        questionTitle,
        itemType,
        answer: shouldRedact && item.answer ? PHI_MASK : item.answer,
      }
    })
  } catch (err) {
    return [{ redactionError: true }]
  }
}

module.exports = {
  toRedacted,
  toLoggableIntakeAnswers,
  PHI_MASK,
}
